import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Breadcrumbs } from '../../shared/models/breadcrumbs';
import { Client } from '../../shared/models/client';
import { Entitlement } from '../../shared/models/entitlement';
import { Service } from '../../shared/models/service';
import { DataService } from '../../shared/services/data-service/data.service';
import { StoreService } from '../../shared/services/store-service/store.service';

@Component({
  standalone: false,
  selector: 'app-entitlement-client',
  templateUrl: './entitlement-client.component.html',
  styleUrls: ['../../app.component.css'],
})
export class EntitlementClientComponent implements OnInit {
  clientId: string;
  client: Client | undefined;
  entitlementClients: Entitlement[];
  loading: boolean;
  searchString: string = '';
  services: Service[] = [];
  expandServiceId: string = '';
  breadcrumbItems: Breadcrumbs[];

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    public storeService: StoreService,
  ) {
    this.loading = true;
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.dataService.initServices();
      await this.dataService.initClients();
      this.clientId = this.route.snapshot.paramMap.get('clientId') || '';
      this.client = this.storeService.clients.find(
        (a) => a.id == this.clientId,
      );
      await this.dataService.initEntitlementByClientId(this.clientId);
      this.entitlementClients = this.storeService.entitlementClients;
    } catch (error) {
      this.loading = false;
    }

    this.entitlementClients.forEach((x) => {
      if (this.services.filter((a) => a.id == x.serviceId).length === 0) {
        let service = this.storeService.services.filter(
          (a) => a.id == x.serviceId,
        )[0];
        this.services.push(service);
        // expand for first service
        if (this.expandServiceId == '') {
          this.expandServiceId = service.id;
        }
      }
    });
    this.buildBreadcrumbs();
    this.loading = false;
  }

  buildBreadcrumbs() {
    this.breadcrumbItems = [
      {
        text: 'Client',
        link: '/client',
      },
      {
        text: this.client?.name!,
        link: '/entitlement-client/' + this.clientId,
      },
    ];
  }

  clearSearch() {
    this.searchString = '';
  }

  expand(serviceId: string) {
    this.expandServiceId = this.expandServiceId == serviceId ? '' : serviceId;
  }
}
